// Copyright 2019, White Label Communications, LLC, All rights reserved.
const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
